<template>
  <org-count-by-direction
    :items="data"
    :total="data.length"
  />
</template>
<script>
import store from '@/store'
import OrgCountByDirection from '@/views/pages/dashboard/chart/CountByDirectionComponent.vue'

export default {
  name: 'DirectionStat',
  components: {
    OrgCountByDirection,
  },
  props: {
    isOtm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      data: [],
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch(`statistic/get${this.isOtm ? 'Org' : 'Min'}DirectionStat`).then(({ data }) => {
      this.data = data
      this.loading = false
    })
  },
  setup() {
    const { dcTypes } = store.state.staticModule
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'name', label: 'Direction' },
    ]
    dcTypes.forEach(x => {
      tableColumns.push({ key: `${x.id}`, label: `${x.name.uz}` })
    })
    tableColumns.push({ key: 'total', label: 'Total' })
    return {
      tableColumns,
    }
  },
}
</script>
